import apiService from './api';

let activeAbortController: AbortController | null = null;

const parseRagResponse = (response: any): string => {
  if (response && response.response) {
    return response.response;
  }
  return "Sorry, I received an empty response. Please try again.";
};

const getGuestSessionId = (): string => {
  let sessionId = localStorage.getItem('guest_chat_session_id');
  if (!sessionId) {
    sessionId = `guest_session_${crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)}`;
    localStorage.setItem('guest_chat_session_id', sessionId);
  }
  return sessionId;
};

export const askKikiService = {
  sendMessage: async (message: string, isPublic: boolean = false): Promise<{ text: string; type?: 'text' | 'actions' | 'ticket_escalation' }> => {
    if (activeAbortController) {
      activeAbortController.abort();
    }
    
    activeAbortController = new AbortController();

    try {
      let response;
      if (isPublic) {
        const sessionId = getGuestSessionId();
        response = await apiService.sendMessageToGuestChatbot(sessionId, message, activeAbortController.signal);
      } else {
        const userId = localStorage.getItem('user_id');
        if (!userId) {
          throw new Error('User ID not found for private chat.');
        }
        response = await apiService.sendMessageToChatbot(userId, message, activeAbortController.signal);
      }
      return {
        text: parseRagResponse(response),
        type: 'text'
      };
    } catch (error: any) {
      if (error?.name === 'AbortError' || error?.message?.includes('aborted')) {
        throw new Error('ABORTED');
      }
      
      return {
        text: "Sorry, I'm having trouble reaching our knowledge base right now. You can: • Try again in a moment • Browse Help & FAQ • Contact Support",
        type: 'text'
      };
    } finally {
      // Only nullify if it's the exact same controller (meaning we weren't superseded by another request)
      if (activeAbortController?.signal.aborted === false) {
        activeAbortController = null;
      }
    }
  }
};
